export enum Countries {
    SPAIN = 'spain',
    ITALY = 'italy',
    ROMANIA = 'romania',
    CZECHIA = 'czechia',
    SLOVAKIA = 'slovakia',
    SLOVAKIA_SHORT = 'sk',
    SPAIN_SHORT = 'ES',
    ITALY_SHORT = 'IT',
    ROMANIA_SHORT = 'RO',
    CZECHIA_SHORT = 'CZ',
    CZECHIA_SHORT_SMALL = 'cz',
    PERU = 'PE',
}

export default Countries;
